import request from '../utils'

const analysisApi = {
    analysisList: async (modelingId, query = "") => {
        const req = request.get(`/api/modeling/modeling-result/${modelingId}${query}`)
        const res = await req;
        return res.body;
    },
    analysisDetail: async (modelingId, resultId) => {
        const req = request.get(`/api/modeling/modeling-result/${modelingId}/${resultId}`)
        const res = await req;
        return res.body;
    },
    analysisDelete: async (modelingId, resultId) => {
        const req = request.delete(`/api/modeling/modeling-result/${modelingId}/${resultId}`)
        await req;
    },
    analyseSelection: async (modelingId, selectionId) => {
        const req = request.get(`/api/modeling/analysis-results-run/${modelingId}/${selectionId}`)
        const res = await req;
        return res.body;
    },
    validateSelection: async (modelingId, selectionId) => {
        const req = request.get(`/api/modeling/validate-selection/${modelingId}/${selectionId}`)
        const res = await req;
        return res.body;
    },
    exportXlsx: (modelingId, resultId) => {
        const req = request.get(`/api/modeling/analysis-results/${modelingId}/${resultId}/xlsx`)
        return req;
    },
    exportLimitXlsx: (modelingId, resultId, limitId) => {
        const req = request.get(`/api/modeling/analysis-results/${modelingId}/${resultId}/${limitId}/xlsx`)
        return req;
    },
    exportResultsCsv: (modelingId, resultId, limitId, query) => {
        const req = request.get(`/api/modeling/analysis-results/${modelingId}/${resultId}/${limitId}/results/csv${query}`)
        return req;
    },
    exportConditionsCsv: (modelingId, resultId, limitId, query) => {
        const req = request.get(`/api/modeling/analysis-results/${modelingId}/${resultId}/${limitId}/conditions/csv${query}`)
        return req;
    },
    exportSpendingCsv: (modelingId, resultId, limitId, query) => {
        const req = request.get(`/api/modeling/analysis-results/${modelingId}/${resultId}/${limitId}/spending/csv${query}`)
        return req;
    },
    exportParameterAndKpiCsv: (modelingId, resultId, limitId, query) => {
        const req = request.get(`/api/modeling/analysis-results/${modelingId}/${resultId}/${limitId}/parameterkpi/csv${query}`)
        return req;
    },
    exportActivityPlanCsv: (modelingId, resultId, query) => {
        const req = request.get(`/api/modeling/analysis-results/${modelingId}/${resultId}/activity-plan/csv${query}`)
        return req;
    },
    exportActivityPlanShp: (modelingId, resultId, query) => {
        const req = request.get(`/api/modeling/analysis-results/${modelingId}/${resultId}/activity-plan/shp${query}`)
        return req;
    },
    weightedGraphCharts: async (modelingId, resultId, limitId, query) => {
        const req = request.get(`/api/modeling/analysis-results/${modelingId}/${resultId}/weighted-graph${query}`)
        const res = await req;
        return res.body;
    },
    activityGraphCharts: async (modelingId, resultId) => {
        const req = request.get(`/api/modeling/analysis-results/${modelingId}/${resultId}/activity-graph`)
        const res = await req;
        return res.body;
    },
    activityPlanData: async (modelingId, resultId, query) => {
        const req = request.get(`/api/modeling/analysis-results/${modelingId}/${resultId}/activity-plan${query}`)
        const res = await req;
        return res.body;
    },
    activityPlanSections: async (modelingId, resultId) => {
        const req = request.get(`/api/modeling/analysis-results/${modelingId}/${resultId}/activity-plan/sections`)
        const res = await req;
        return res.body;
    },
    distributionCharts: async (modelingId, resultId) => {
        const req = request.get(`/api/modeling/analysis-results/${modelingId}/${resultId}/distribution-graph`)
        const res = await req;
        return res.body;
    },
    sumarizedCostGraph: async (modelingId, resultId) => {
        const req = request.get(`/api/modeling/analysis-results/${modelingId}/${resultId}/sumarized-cost-graph`)
        const res = await req;
        return res.body;
    }
};

export default analysisApi;